var _clipPath, _clipPath2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v30 h60 v-30 z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v30 h60 v-30 z",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.46 h60 M0,6.92 h60 M0,10.38 h60 M0,13.85 h60 M0,17.31 h60 M0,20.77 h60 M0,24.23 h60 M0,27.69 h60",
    stroke: "#fff",
    strokeWidth: 2.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v15 h30 v-15 z",
    fill: "#3c3b6e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M2.5,1.5 l0.8,2.5 l-2.1,-1.5 h2.6 l-2.1,1.5 z"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#a",
    y: 3
  }), /*#__PURE__*/React.createElement("use", {
    href: "#a",
    y: 6
  }), /*#__PURE__*/React.createElement("use", {
    href: "#a",
    y: 9
  }), /*#__PURE__*/React.createElement("use", {
    href: "#a",
    y: 12
  })), /*#__PURE__*/React.createElement("use", {
    href: "#b",
    x: 5
  })), /*#__PURE__*/React.createElement("use", {
    href: "#e",
    x: 10
  })), /*#__PURE__*/React.createElement("use", {
    href: "#c",
    x: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.2f92bcc55a0551f49b0dc20cbc511d5d.svg";
export { ForwardRef as ReactComponent };